import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "user-dataset-table-container" }
const _hoisted_2 = {
  key: 0,
  id: "utdc--error"
}
const _hoisted_3 = { id: "utdc--samples" }
const _hoisted_4 = {
  key: 1,
  id: "utdc--folded"
}

import { computed } from 'vue';
import type { Prettify, UserDataset, UnifiedRegion } from '@/types';
import type { FoldedTimeSeriesData, } from '@/esri/services/aggregation';
import type { TimeBinOptions, FoldingPeriodOptions } from './DataFoldingAndBinning.vue';


import tz_lookup from '@photostructure/tz-lookup';



export default /*@__PURE__*/_defineComponent({
  __name: 'UserDatasetTable',
  props: {
    dataset: {}
  },
  emits: ["rowClick"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable @typescript-eslint/no-unused-vars */
function regionCenter(region: UnifiedRegion): { lat: number; lon: number } {
  if (region.geometryType === 'point') {
    return { lat: region.geometryInfo.y, lon: region.geometryInfo.x };
  } else {
    const lat = (region.geometryInfo.ymin + region.geometryInfo.ymax) / 2;
    const lon = (region.geometryInfo.xmin + region.geometryInfo.xmax) / 2;
    return { lat, lon };
  }
}

const props = __props;

const samples = props.dataset.samples;
const errors = props.dataset.errors;
const center = regionCenter(props.dataset.region);
const tz = tz_lookup(center.lat, center.lon);

const errorMessage = computed(() => {
  if (samples === undefined) {
    return 'No samples available in this dataset.';
  }
  if (Object.keys(samples).length === 0) {
    return 'Samples has length 0 for this dataset';
  }
  return null;
});

const toDate = (date: Date) => date.toLocaleDateString(undefined, {dateStyle: 'medium'});
const toTime = (date: Date) => date.toLocaleTimeString(undefined, {
  hour12:true, hour:'numeric', minute: '2-digit', second:'2-digit',
  timeZone: tz,
});

const sampleHeaders = [
  { 
    title: 'Date' , 
    key: 'date',
    value: item => toDate(item.date),
  },
  { 
    title: 'Local Time', 
    key: 'localTime',
    value: item => toTime(item.date) 
  },
  { 
    title: 'Column Density (error)',
    children: [{
      title: '10¹⁴ molecules/cm²',
      key: 'columnDensity',
      value: item => `${item.value ? (item.value / 1e14).toFixed(2) : 'N/A'} (${item.error ? (item.error / 1e14).toFixed(2) : 'N/A'})`,
    }]
  },
];
const samplesItems = computed(() => {
  if (!samples) {
    return [];
  }
  return Object.entries(samples).map(([key, value]) => ({
    date: value.date,
    value: value.value,
    error: errors ? errors[key]?.upper : undefined,
  }));
});


const folded = props.dataset.folded;
const timeBin = props.dataset.folded?.timeBin as TimeBinOptions | undefined; 
const foldPeriod = props.dataset.folded?.foldPeriod as FoldingPeriodOptions | undefined;
const foldedData = props.dataset.folded?.raw as FoldedTimeSeriesData | undefined;
console.log('foldedData', foldedData);  


const foldedHeaders = [
  { 
    title: 'Bin' , 
    key: 'date',
  },
  { 
    title: 'Column Density (error)',
    children: [{
      title: '10¹⁴ molecules/cm²',
      key: 'columnDensity',
      value: item => `${item.value ? (item.value / 1e14).toFixed(2) : 'N/A'} (${item.error ? (item.error / 1e14).toFixed(2) : 'N/A'})`,
    }]
  },
];
const foldedItems = computed(() => {
  if (!foldedData) {
    return [];
  }
  return Object.entries(foldedData.values).map(([key, value]) => ({
    date: value.bin,
    value: value.value,
    error: foldedData.errors ? foldedData.errors[key]?.upper : undefined,
  }));
});

const emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_unref(samples) && Object.keys(_unref(samples)).length > 0)
        ? (_openBlock(), _createBlock(_component_v_data_table, {
            key: 0,
            items: samplesItems.value,
            headers: sampleHeaders,
            "onClick:row": _cache[0] || (_cache[0] = ($event: any) => (emits('rowClick', $event.item)))
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(folded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(folded))
            ? (_openBlock(), _createBlock(_component_v_data_table, {
                key: 0,
                headers: foldedHeaders,
                items: foldedItems.value,
                "onClick:row": _cache[1] || (_cache[1] = ($event: any) => (emits('rowClick', $event.item)))
              }, null, 8, ["items"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})